import { render } from "./Sidebar.vue?vue&type=template&id=a89e7bc2&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=a89e7bc2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a89e7bc2"

export default script